import { render } from "./trademarkList.vue?vue&type=template&id=547761fe&scoped=true"
import script from "./trademarkList.vue?vue&type=script&lang=js"
export * from "./trademarkList.vue?vue&type=script&lang=js"

import "./trademarkList.vue?vue&type=style&index=0&id=547761fe&scoped=true&lang=css"
import "./trademarkList.vue?vue&type=style&index=1&id=547761fe&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547761fe"]])

export default __exports__